export default __webpack_public_path__ + "static/media/logo.ed8ec367.png";